export default function AMCommonQuantity() {
  const WRAPPER_CLASS = 'js-am-quantity';
  const MINUS_BUTTON_CLASS = 'js-am-quantity__button-minus';
  const PLUS_BUTTON_CLASS = 'js-am-quantity__button-plus';

  const INACTIVE_CLASS = 'scout-element__counter-button--inactive';

  this.value = null;
  this.parentClass = null;

  this.initiate = (parentClass) => {
    if (parentClass) {
      this.parentClass = parentClass;
    }
    this.initiateMinMax();
    this.initiateButtons();
  };

  this.initiateMinMax = () => {
    const DEFAULT_MIN = 1;
    const DEFAULT_MAX = 30;

    const $input = this.getInput();
    const minAttr = $input.attr('min');
    const maxAttr = $input.attr('max');
    this.min = minAttr ? parseInt(minAttr, 10) : DEFAULT_MIN;
    this.max = maxAttr ? parseInt(maxAttr, 10) : DEFAULT_MAX;
    this.value = this.min;
  };

  this.initiateButtons = () => {
    this.getSelector(MINUS_BUTTON_CLASS).click((e) => {
      e.preventDefault();
      const $button = $(e.currentTarget);
      if ($button.attr('disabled')) {
        return;
      }
      this.subtract();
    });

    this.getSelector(PLUS_BUTTON_CLASS).click((e) => {
      e.preventDefault();
      const $button = $(e.currentTarget);
      if ($button.attr('disabled')) {
        return;
      }
      this.add();
    });
  };

  this.getInput = () => this.getSelector(WRAPPER_CLASS).find('input');

  this.subtract = () => {
    if (this.value === this.min) {
      return;
    }

    this.value -= 1;
    this.updateValue();
  };

  this.add = () => {
    if (this.value === this.max) {
      return;
    }

    this.value += 1;
    this.updateValue();
  };

  this.updateValue = () => {
    this.getInput()
      .val(this.value)
      .trigger('change');

    const $minus = this.getSelector(MINUS_BUTTON_CLASS);
    const $plus = this.getSelector(PLUS_BUTTON_CLASS);

    this.enableSelector($plus);
    this.enableSelector($minus);

    if (this.value === this.min) {
      this.disableSelector($minus);
    }
    if (this.value === this.max) {
      this.disableSelector($plus);
    }
  };

  this.getSelector = (className) => $(!this.parentClass ? `.${className}` : `.${this.parentClass} .${className}`);

  this.disableSelector = ($selector) => {
    $selector.prop('disabled', true);
    $selector.addClass(INACTIVE_CLASS);
  };

  this.enableSelector = ($selector) => {
    $selector.prop('disabled', false);
    $selector.removeClass(INACTIVE_CLASS);
  };
}
